import React from 'react'
import { useAuth } from 'react-oidc-context'
import { Redirect, Route, withRouter } from 'react-router-dom'

const PrivateRoute = withRouter(({ children, location, ...rest }) => {
  const auth = useAuth()
  const returnTo = encodeURIComponent(location.pathname + location.search)
  return <Route {...rest}>{auth.isAuthenticated ? children : <Redirect to={`/signin?returnTo=${returnTo}`} />}</Route>
})

export default PrivateRoute
